export enum UserKey {
  USERS = 'users',
  USER_GROUPS = 'userGroups',
  USERS_INFINITE = 'usersInfinite',
}
